import reports from "./reports";

export const REPORTS_NAMESPACE = "reports";

export default reports;
